import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './RequirementAndRelievedEmployeesList.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDistrict, getProject, getStates, fetchMonths, getEmployeeSummaryDrilldownFullDetails } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';
import { getPostedAndRelievedCount, getPostedAndRelievedCountDrilldown, getPostedAndRelievedCountDistDrilldown } from '../../../services/employeePostingService';
import { format } from 'date-fns';
import { saveAs } from 'file-saver';
const RequirementAndRelievedEmployeesList = () => {
    const currentYear = new Date().getFullYear();
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(currentYear);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);
    const [clientResponse, setClientResponse] = useState([]);
    const [clients, setClients] = useState(1);
    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        month: false,
        year: false,
        project: false,
        clients: false,
        designation: false
    });
    const [errors, setErrors] = useState({});
    const yearInputRef = useRef(null);
    const [designationData, setDesignationData] = useState([]);

    const [designationOptions, setDesignationOptions] = useState([]);
    const [designation, setDesignation] = useState("");
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const isFetchDataEnabled = state && month && year;

    // Add these with your other useState declarations
    const [drillDownData, setDrillDownData] = useState([]);
    const [selectedDesignation, setSelectedDesignation] = useState(null);
    const [isDrillDown, setIsDrillDown] = useState(false);
    const [drillDownLoading, setDrillDownLoading] = useState(false);

    // ===== LEVEL 2 DRILL-DOWN (Employee Level) =====
    const [employeeData, setEmployeeData] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [viewLevel, setViewLevel] = useState(1); // 1 = main, 2 = district, 3 = employee
    const [employeeLoading, setEmployeeLoading] = useState(false);


    // ===== LEVEL 3 DRILL-DOWN (Employee Level) =====
    const [employeeDataFullDetails, setEmployeeDataFullDetails] = useState([]);
    const [employeeFullDetails, setEmployeeFullDetails] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [employeeDetailsLoading, setEmployeeDetailsLoading] = useState(false);

    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);




    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);


    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            // if (!effectRan.current) {
            fetchDistricts();
            // }
            // return () => {
            //     effectRan.current = true;
            // }

        } else {
            setDistrictOptions([]);
            setDistrict(null);
        }
    }, [state]);





    // Clear attendance data and fetch status when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);
        // setOriginalData([]);
        setHasFetched(false);
    }, [state, district, month, year, project]); // ✅ Add project to depende

    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setClients(null);
                setProject(null); // ✅ Clear project when state changes

                break;
            case 'district':
                setDistrict(value);
                // setProject(null); // ✅ Clear project when district changes
                break;

            case 'month':
                setMonth(value);
                break;

            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const handleYearChange = (date) => {
        setYear(date ? date.getFullYear() : null);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const data = await getPostedAndRelievedCount(state, district, year, month,)

            const employeeData = data || [];

            setAttendanceData(employeeData);

        } catch (error) {
            console.error("Error fetching reportrarel data:", error);
            setErrors((prev) => ({
                ...prev,
                general: "Failed to fetch reportrarel data",
            }));
            alert("Failed to fetch reportrarel data. Please try again.");
        }
    };
    // ===== LEVEL 1: Click on designation → show district-wise =====
    const handleDesignationClick = async (designation) => {
        if (!designation) return;

        try {
            setDrillDownLoading(true);
            setSelectedDesignation(designation);
            setViewLevel(2);
            setDrillDownData([]);

            const data = await getPostedAndRelievedCountDrilldown(
                state, district, year, month, designation
            );

            setDrillDownData(data.summary || data || []);
        } catch (error) {
            console.error("Error fetching drill-down data:", error);
            setErrors(prev => ({ ...prev, general: "Failed to fetch drill-down data" }));
        } finally {
            setDrillDownLoading(false);
        }
    };

    // ===== LEVEL 2: Click on district → show employee-wise =====
    const handleDistrictClick = async (districtRow) => {
        if (!districtRow?.districtId) return;

        try {
            setEmployeeLoading(true);
            setSelectedDistrict(districtRow);
            setViewLevel(3);
            setEmployeeData([]);

            const data = await getPostedAndRelievedCountDistDrilldown(districtRow.districtId, year, month,
            );

            setEmployeeData(Array.isArray(data) ? data : (data.summary || []));
        } catch (error) {
            console.error("Error fetching employee data:", error);
            setErrors(prev => ({ ...prev, general: "Failed to fetch employee data" }));
        } finally {
            setEmployeeLoading(false);
        }
    };

    // =============== Leve 3: Employee FullDetails =================
    // ===== LEVEL 3: Click on employee → show full details =====
    const handleEmployeeClick = async (employeeRow) => {
        if (!employeeRow?.employeeUniqueId) {
            console.warn("No employeeUniqueId found on row:", employeeRow);
            return;
        }

        try {
            setEmployeeDetailsLoading(true);
            setSelectedEmployee(employeeRow);
            setViewLevel(4);
            setEmployeeFullDetails(null);

            const data = await getEmployeeSummaryDrilldownFullDetails(
                year,
                month,
                employeeRow.employeeUniqueId
            );

            setEmployeeFullDetails(data || null);
        } catch (error) {
            console.error("Error fetching employee full details:", error);
            setErrors(prev => ({ ...prev, general: "Failed to fetch employee details" }));
        } finally {
            setEmployeeDetailsLoading(false);
        }
    };

    // ===== Back button logic (multi-level) =====
    const handleBackToMain = () => {
        // Level 4 → back to Level 3
        if (viewLevel === 4) {
            setViewLevel(3);
            setEmployeeFullDetails(null);
            setSelectedEmployee(null);
            return;
        }
        // Level 3 → back to Level 2
        if (viewLevel === 3) {
            setViewLevel(2);
            setEmployeeData([]);
            setSelectedDistrict(null);
            return;
        }
        // Level 2 → back to Level 1
        if (viewLevel === 2) {
            setViewLevel(1);
            setDrillDownData([]);
            setSelectedDesignation(null);
            return;
        }
        setViewLevel(1);
    };

    // Reset everything when filters change
    useEffect(() => {
        setViewLevel(1);
        setDrillDownData([]);
        setEmployeeData([]);
        setEmployeeFullDetails(null);
        setSelectedEmployee(null);
        setSelectedDesignation(null);
        setSelectedDistrict(null);
    }, [state, district, month, year]);


    // const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);

    // ===================== HELPERS =====================

    const getFilterLabels = () => {
        const stateLabel = stateOptions.find(o => o.value === state)?.label || 'All';
        const districtLabel = districtOptions.find(o => o.value === district)?.label || 'All';
        const monthLabel = monthOptions.find(o => o.value === month)?.label || 'All';
        return {
            stateLabel,
            districtLabel,
            monthLabel,
            year: year || 'All'
        };
    };

    const getReportTitle = () => {
        if (viewLevel === 1) return 'Designation-wise Recruited & Relieved Summary';
        if (viewLevel === 2) return `District-wise Details — ${selectedDesignation || ''}`;
        if (viewLevel === 3) return `Employee Details — ${selectedDistrict?.districtName || ''} (${selectedDesignation || ''})`;
        return 'Recruited & Relieved Employees Report';
    };

    const getTableData = () => {
        if (viewLevel === 1) {
            return attendanceData.map((row, idx) => [
                idx + 1,
                row.designation || '',
                row.postedCount || 0,
                row.relievedCount || 0
            ]);
        }
        if (viewLevel === 2) {
            return drillDownData.map((row, idx) => [
                idx + 1,
                row.districtName || '',
                row.postedCount || 0,
                row.relievedCount || 0
            ]);
        }
        if (viewLevel === 3) {
            return employeeData.map((row, idx) => [
                idx + 1,
                row.employeeName || '',
                row.designation || '',
                row.contactNumber || '',
                row.postingDate
                    ? format(new Date(row.postingDate), 'dd-MM-yyyy')
                    : row.resignationDate
                        ? format(new Date(row.resignationDate), 'dd-MM-yyyy')
                        : row.terminationDate
                            ? format(new Date(row.terminationDate), 'dd-MM-yyyy')
                            : '',
                row.status || ''
            ]);
        }
        return [];
    };

    const getTableHeaders = () => {
        if (viewLevel === 1) return ['S.No', 'Designation', 'Posted Count', 'Relieved Count'];
        if (viewLevel === 2) return ['S.No', 'District Name', 'Posted Count', 'Relieved Count'];
        if (viewLevel === 3)
            return ['S.No', 'Employee Name', 'Designation', 'Mobile Number', 'Recruited/Relieved Date', 'Status'];
        return [];
    };

    const getColumnWidths = () => {
        if (viewLevel === 1) return [8, 30, 15, 15];
        if (viewLevel === 2) return [8, 30, 15, 15];
        if (viewLevel === 3) return [8, 25, 20, 16, 20, 12];
        return [];
    };

    const getFooterRow = () => {
        if (viewLevel === 1 && attendanceData.length > 0) {
            return [
                '',
                'Total',
                attendanceData.reduce((s, r) => s + (r.postedCount || 0), 0),
                attendanceData.reduce((s, r) => s + (r.relievedCount || 0), 0)
            ];
        }
        if (viewLevel === 2 && drillDownData.length > 0) {
            return [
                '',
                'Total',
                drillDownData.reduce((s, r) => s + (r.postedCount || 0), 0),
                drillDownData.reduce((s, r) => s + (r.relievedCount || 0), 0)
            ];
        }
        return null;
    };

    const handleDownloadExcel = async () => {
        const data = getTableData();
        if (data.length === 0) {
            alert('No data available to download. Please generate the report first.');
            return;
        }

        try {
            const workbook = new ExcelJS.Workbook();
            workbook.creator = 'Recruited & Relieved Report System';
            workbook.created = new Date();

            const worksheet = workbook.addWorksheet('Report', {
                views: [{ state: 'frozen', ySplit: 7 }]
            });
            const { stateLabel, districtLabel, monthLabel, year: yearLabel } = getFilterLabels();
            const headers = getTableHeaders();
            const lastCol = headers.length;
            const lastColLetter = String.fromCharCode(64 + lastCol); // A=1 → A, D=4, F=6 etc.

            // ===== 1. Title =====
            const titleRow = worksheet.addRow([getReportTitle()]);
            titleRow.font = { size: 16, bold: true, color: { argb: 'FFFFFFFF' } };
            titleRow.alignment = { horizontal: 'center', vertical: 'middle' };
            titleRow.height = 30;
            worksheet.mergeCells(`A1:${lastColLetter}1`);
            titleRow.eachCell((cell) => {
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F4E78' } };
                cell.border = {
                    top: { style: 'thin' }, left: { style: 'thin' },
                    bottom: { style: 'thin' }, right: { style: 'thin' }
                };
            });

            // ===== 2. Generated Date & Time =====
            const now = new Date();
            const genDate = format(now, 'dd-MM-yyyy');
            const genTime = format(now, 'HH:mm:ss');
            const dateRow = worksheet.addRow([`Report Generated On: ${genDate}   |   Time: ${genTime}`]);
            dateRow.font = { size: 11, italic: true, bold: true, color: { argb: 'FF333333' } };
            dateRow.alignment = { horizontal: 'right', vertical: 'middle' };
            dateRow.height = 20;
            worksheet.mergeCells(`A2:${lastColLetter}2`);


            // ===== 3. Selected Filters =====
            const filterHeader = worksheet.addRow(['Selected Filters']);
            filterHeader.font = { size: 12, bold: true, color: { argb: 'FFFFFFFF' } };
            filterHeader.alignment = { horizontal: 'center', vertical: 'middle' };
            filterHeader.height = 22;
            worksheet.mergeCells(`A3:${lastColLetter}3`);
            filterHeader.eachCell((cell) => {
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2E75B6' } };
                cell.border = {
                    top: { style: 'thin' }, left: { style: 'thin' },
                    bottom: { style: 'thin' }, right: { style: 'thin' }
                };
            });

            // --- Filter line 1 ---
            const filterLine1 = worksheet.addRow([
                `State: ${stateLabel}    |    District: ${districtLabel}    |    Month: ${monthLabel}    |    Year: ${yearLabel}`
            ]);
            filterLine1.font = { size: 11 };
            filterLine1.alignment = { horizontal: 'left', vertical: 'middle', indent: 1 };
            filterLine1.height = 20;
            worksheet.mergeCells(`A4:${lastColLetter}4`);

           
          
            worksheet.mergeCells(`A5:${lastColLetter}5`);

            // ===== 4. Spacer =====
            worksheet.addRow([]);
            worksheet.getRow(6).height = 8;

            // ===== 5. Table Header =====
            const headerRow = worksheet.addRow(headers);
            headerRow.height = 26;
            headerRow.eachCell((cell) => {
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
                cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4472C4' } };
                cell.border = {
                    top: { style: 'thin' }, left: { style: 'thin' },
                    bottom: { style: 'thin' }, right: { style: 'thin' }
                };
            });

            // ===== 6. Data Rows =====
            data.forEach((rowData, index) => {
                const row = worksheet.addRow(rowData);
                row.height = 20;
                row.eachCell((cell, colNumber) => {
                    cell.alignment = {
                        horizontal: colNumber === 1 ? 'center' : 'left',
                        vertical: 'middle',
                        wrapText: true
                    };
                    cell.font = { size: 10 };
                    cell.border = {
                        top: { style: 'thin', color: { argb: 'FFD0D0D0' } },
                        left: { style: 'thin', color: { argb: 'FFD0D0D0' } },
                        bottom: { style: 'thin', color: { argb: 'FFD0D0D0' } },
                        right: { style: 'thin', color: { argb: 'FFD0D0D0' } }
                    };
                    if (index % 2 === 1) {
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F2F2' } };
                    }
                });
            });

            // ===== 7. Footer Total Row =====
            const footer = getFooterRow();
            if (footer) {
                const footerRow = worksheet.addRow(footer);
                footerRow.height = 22;
                footerRow.eachCell((cell) => {
                    cell.font = { bold: true, size: 11 };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF2CC' } };
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    cell.border = {
                        top: { style: 'thin' }, left: { style: 'thin' },
                        bottom: { style: 'thin' }, right: { style: 'thin' }
                    };
                });
            }

            // ===== 8. Column Widths =====
            const widths = getColumnWidths();
            widths.forEach((w, i) => { worksheet.getColumn(i + 1).width = w; });

            // ===== 9. Auto filter =====
            worksheet.autoFilter = {
                from: { row: 7, column: 1 },
                to: { row: 7, column: lastCol }
            };

            // ===== 10. Save =====
            const safeName = getReportTitle().replace(/[^a-z0-9]/gi, '_');
            const fileName = `${safeName}_${genDate.replace(/-/g, '')}_${genTime.replace(/:/g, '')}.xlsx`;
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            saveAs(blob, fileName);
        } catch (error) {
            console.error('Excel generation error:', error);
            alert('Failed to generate Excel. Please try again.');
        }
    };
    const handleDownloadPDF = () => {
        const data = getTableData();
        if (data.length === 0) {
            alert('No data available to download. Please generate the report first.');
            return;
        }

        try {
            const doc = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4'
            });

            const { stateLabel, districtLabel, monthLabel, year: yearLabel } = getFilterLabels();
            const headers = getTableHeaders();
            const now = new Date();
            const genDate = format(now, 'dd-MM-yyyy');
            const genTime = format(now, 'HH:mm:ss');
            const pageWidth = doc.internal.pageSize.getWidth();

            // ===== 1. Title =====
            doc.setFillColor(31, 78, 120);
            doc.rect(0, 0, pageWidth, 14, 'F');
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(14);
            doc.setFont('helvetica', 'bold');
            doc.text(getReportTitle(), pageWidth / 2, 9, { align: 'center' });

            // ===== 2. Generated Date/Time =====
            doc.setTextColor(60, 60, 60);
            doc.setFontSize(9);
            doc.setFont('helvetica', 'italic');
            doc.text(`Generated On: ${genDate}  |  Time: ${genTime}`, pageWidth - 10, 20, { align: 'right' });

            // ===== 3. Filters =====
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(10);
            doc.setTextColor(31, 78, 120);
            doc.text('Selected Filters:', 14, 20);

            doc.setFont('helvetica', 'normal');
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(9);
            const filterLine1 = `State: ${stateLabel}   |   District: ${districtLabel}   |   Month: ${monthLabel}   |   Year: ${yearLabel}`;
            doc.text(filterLine1, 14, 26);


            // ===== 4. Table =====
            let finalY = 36;
            doc.autoTable({
                head: [headers],
                body: data,
                startY: finalY,
                theme: 'grid',
                styles: {
                    fontSize: 9,
                    cellPadding: 2.5,
                    valign: 'middle',
                    lineColor: [200, 200, 200],
                    lineWidth: 0.2
                },
                headStyles: {
                    fillColor: [68, 114, 196],
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                    halign: 'center',
                    fontSize: 10
                },
                bodyStyles: {
                    textColor: [0, 0, 0]
                },
                alternateRowStyles: {
                    fillColor: [242, 242, 242]
                },
                columnStyles: {
                    0: { halign: 'center', cellWidth: 15 }
                },
                foot: getFooterRow() ? [getFooterRow()] : undefined,
                footStyles: {
                    fillColor: [255, 242, 204],
                    textColor: [0, 0, 0],
                    fontStyle: 'bold',
                    halign: 'center'
                },
                didDrawPage: (dataArg) => {
                    // Page footer
                    const pageCount = doc.internal.getNumberOfPages();
                    const pageNum = doc.internal.getCurrentPageInfo().pageNumber;
                    doc.setFontSize(8);
                    doc.setTextColor(120, 120, 120);
                    doc.text(
                        `Page ${pageNum} of ${pageCount}`,
                        pageWidth / 2,
                        doc.internal.pageSize.getHeight() - 5,
                        { align: 'center' }
                    );
                }
            });

            const safeName = getReportTitle().replace(/[^a-z0-9]/gi, '_');
            const fileName = `${safeName}_${genDate.replace(/-/g, '')}_${genTime.replace(/:/g, '')}.pdf`;
            doc.save(fileName);
        } catch (error) {
            console.error('PDF generation error:', error);
            alert('Failed to generate PDF. Please try again.');
        }
    };

    return (
        <div className="rarel-reportrarel-container">
            <div className="rarel-reportrarel-box">
                <h2 className="rarel-reportrarel-heading">Recruited and Relieved Employees List</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}
                >
                    <div className="rarel-reportrarel-maincontainer">
                        <div className="rarel-reportrarel-container-part">
                            <div className={`rarel-reportrarel-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="rarel-reportrarel-container-part">
                            <div className={`rarel-reportrarel-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label> District</label>
                                {/* {errors.district && <div className="error-message">{errors.district}</div>} */}
                            </div>
                        </div>
                    </div>

                    <div className="rarel-reportrarel-maincontainer">
                        {/* <div className="rarel-reportrarel-container-part">
                            <div className={`rarel-reportrarel-floating-label-container ${isFocused.designation || designation ? 'float-label' : ''}`}>
                                <Select
                                    name="designation"
                                    options={designationOptions}
                                    value={designationOptions.find(opt => opt.value === designation) || null}
                                    onChange={option => handleInputChange(option, "designation")}
                                    
                                    isClearable
                                    className="w-100"
                                />
                                <label>Designation</label>
                                
                            </div>
                        </div> */}
                        <div className="rarel-reportrarel-container-part">
                            <div className={`rarel-reportrarel-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="rarel-reportrarel-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}

                                    title="Select a year"
                                />
                                <label><span className="required">*</span>Year</label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>
                        <div className="rarel-reportrarel-container-part">
                            <div className={`rarel-reportrarel-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Month</label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div>
                        </div>

                    </div>

                    {/* <div className="rarel-reportrarel-maincontainer">
                        
                        <div className="rarel-reportrarel-container-part">

                        </div>

                    </div> */}

                    <div className="rarel-reportrarel-btn-div">
                        <button
                            type="submit"
                            className="rarel-reportrarel-btn"
                            disabled={!isFetchDataEnabled}
                        >
                            Generate Report
                        </button>

                        {/* Show download buttons only when data is present */}
                        {((viewLevel === 1 && attendanceData.length > 0) ||
                            (viewLevel === 2 && drillDownData.length > 0) ||
                            (viewLevel === 3 && employeeData.length > 0)) && (
                                <>
                                    <button
                                        type="button"
                                        className="rarel-reportrarel-btn"
                                        onClick={handleDownloadExcel}
                                        style={{ marginLeft: '10px', backgroundColor: '#1F7A3D' }}
                                    >
                                        Download Excel
                                    </button>
                                    <button
                                        type="button"
                                        className="rarel-reportrarel-btn"
                                        onClick={handleDownloadPDF}
                                        style={{ marginLeft: '10px', backgroundColor: '#B22222' }}
                                    >
                                        Download PDF
                                    </button>
                                </>
                            )}
                    </div>
                </form>
            </div>


            <div className="reportrarel-table-monthlt-att-container">

                {/* ===================== LEVEL 1: MAIN SUMMARY ===================== */}
                {viewLevel === 1 && (
                    <table className="reportrarel-table-monthlt-att">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Designation</th>
                                <th>Posted Count</th>
                                <th>Relieved Count</th>
                                {/* <th>Difference</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {attendanceData.length > 0 ? (
                                attendanceData.map((row, idx) => {
                                    // const vacancy = Math.abs((row.fieldCount || 0) - (row.appAttendanceCount || 0));
                                    return (
                                        <tr
                                            key={idx}
                                            onClick={() => handleDesignationClick(row.designation)}
                                            className="clickable-row"
                                            style={{ cursor: "pointer" }}
                                            title={`View district-wise details for ${row.designation}`}
                                        >
                                            <td>{idx + 1}</td>
                                            <td>{row.designation}</td>
                                            <td>{row.postedCount}</td>
                                            <td>{row.relievedCount}</td>
                                            {/* <td>{vacancy}</td> */}
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                                        No attendance data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        {attendanceData.length > 0 && (
                            <tfoot>
                                <tr className="reportrarel-total-row bg-warning-subtle">
                                    <td colSpan="2" className="reportrarel-total-label">Total</td>
                                    <td>{attendanceData.reduce((s, r) => s + (r.postedCount || 0), 0)}</td>
                                    <td>{attendanceData.reduce((s, r) => s + (r.relievedCount || 0), 0)}</td>
                                    {/* Level 1 */}
                                    {/* <td>
                                        {attendanceData.reduce(
                                            (s, r) => s + Math.abs((r.fieldCount || 0) - (r.appAttendanceCount || 0)),
                                            0
                                        )}
                                    </td> */}
                                </tr>
                            </tfoot>
                        )}
                    </table>
                )}

                {/* ===================== LEVEL 2: DISTRICT DRILL-DOWN ===================== */}
                {viewLevel === 2 && (
                    <>
                        <div className="reportrarel-header">
                            <h3 className="reportrarel-title">
                                District-wise Details for: <strong>{selectedDesignation}</strong>
                            </h3>
                            <button type="button" className="back-btn" onClick={handleBackToMain}>
                                ← Back to Summary
                            </button>
                        </div>

                        <table className="reportrarel-table-monthlt-att">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>District Name</th>
                                    <th>Posted Count</th>
                                    <th>Relieved Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                {drillDownLoading ? (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                                            Loading...
                                        </td>
                                    </tr>
                                ) : drillDownData.length > 0 ? (
                                    drillDownData.map((row, idx) => {
                                        // const difference = Math.abs((row.fieldCount || 0) - (row.appAttendanceCount || 0));
                                        return (
                                            <tr
                                                key={row.districtId || idx}
                                                onClick={() => handleDistrictClick(row)}
                                                className="clickable-row"
                                                style={{ cursor: "pointer" }}
                                                title={`View employees in ${row.districtName}`}
                                            >
                                                <td>{idx + 1}</td>
                                                <td>{row.districtName}</td>
                                                <td>{row.postedCount}</td>
                                                <td>{row.relievedCount}</td>
                                                {/* <td>{difference}</td> */}
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                                            No district data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                            {drillDownData.length > 0 && (
                                <tfoot>
                                    <tr className="reportrarel-total-row bg-warning-subtle">
                                        <td colSpan="2" className="reportrarel-total-label">Total</td>
                                        <td>{drillDownData.reduce((s, r) => s + (r.postedCount || 0), 0)}</td>
                                        <td>{drillDownData.reduce((s, r) => s + (r.relievedCount || 0), 0)}</td>
                                        {/* Level 2 */}
                                        {/* <td>
                                            {drillDownData.reduce(
                                                (s, r) => s + Math.abs((r.fieldCount || 0) - (r.appAttendanceCount || 0)),
                                                0
                                            )}
                                        </td> */}
                                    </tr>
                                </tfoot>
                            )}
                        </table>
                    </>
                )}

                {/* ===================== LEVEL 3: EMPLOYEE DRILL-DOWN ===================== */}
                {viewLevel === 3 && (
                    <>
                        <div className="reportrarel-header">
                            <h3 className="reportrarel-title">
                                Employees in <strong>{selectedDistrict?.districtName}</strong> —{" "}
                                <strong>{selectedDesignation}</strong>
                            </h3>
                            <button type="button" className="back-btn" onClick={handleBackToMain}>
                                ← Back to District List
                            </button>
                        </div>

                        <table className="reportrarel-table-monthlt-att">
                            <thead>
                                <tr>
                                    <th>S.No</th>

                                    <th>Employee Name</th>
                                    <th>Designation</th>
                                    <th>Mobile Number</th>
                                    <th>Recruited/Relieved  Date</th>
                                    <th>Status</th>

                                </tr>
                            </thead>
                            <tbody>
                                {employeeLoading ? (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                                            Loading...
                                        </td>
                                    </tr>
                                ) : employeeData.length > 0 ? (
                                    employeeData.map((row, idx) => {

                                        return (
                                            // ✅ CORRECT — pass function reference
                                            <tr
                                                key={row.employeeId || idx}
                                                // onClick={() => handleEmployeeClick(row)}
                                                className="clickable-row"
                                                style={{ cursor: "pointer" }}
                                                title={`View details for ${row.employeeName}`}
                                            >
                                                <td>{idx + 1}</td>

                                                <td>{row.employeeName}</td>
                                                <td>{row.designation}</td>
                                                <td>{row.contactNumber}</td>
                                                <td>{format(row.postingDate, "dd-MM-yyyy") || format(row.resignationDate, "dd-MM-yyyy") || format(row.terminationDate, "dd-MM-yyyy")}</td>
                                                <td>{row.status}</td>

                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                                            No employee data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </>
                )}


            </div>

        </div>
    );
};

export default RequirementAndRelievedEmployeesList;